<template>
  <div>
    <!-- <div class="select-group" v-for="(facet, index) in facets"
      :key="facet.name"
    >
      {{facet.name}}
      <multiselect v-model="value[facet.name]" :options="facet.allValues" placeholder="Filter by.." label="label" track-by="label"></multiselect>
    </div> -->
    <div v-if="windowSmall">
      <h4 @click="show = !show" class="filter-toggle">
        Filter by <i class="icon-caret-right" v-if="!show"></i>
        <i class="icon-caret-down" v-if="show"></i>
      </h4>
    </div>

    <h4 v-else>Filter by</h4>

    <!-- Better way to do the below -->
    <template v-if="windowSmall">
      <div :class="show ? 'show-filters' : 'hide-filters'">
        <div
          class="select-group"
          v-for="(facet, index) in cleanedFacets"
          :key="facet.name"
          v-if="facet.allValues.length"
        >
          <label
            ><h5>{{ facet.name }}</h5></label
          >

          <!-- <multiselect v-model="value[facet.name]" :options="facet.allValues" placeholder="Filter by.." label="label" track-by="label"></multiselect> -->
          <vSelect
            :options="facet.allValues"
            v-model="value[facet.name]"
            :placeholder="`Filter by ${facet.name}`"
            label="label"
            @input="filterClick($event, facet.name)"
          ></vSelect>
        </div>
      </div>
    </template>

    <template v-else>
      <div>
        <div
          class="select-group"
          v-for="(facet, index) in cleanedFacets"
          :key="facet.name"
          v-if="facet.allValues.length"
        >
          <label
            ><h5>{{ facet.name }}</h5></label
          >

          <!-- <multiselect v-model="value[facet.name]" :options="facet.allValues" placeholder="Filter by.." label="label" track-by="label"></multiselect> -->
          <vSelect
            :options="facet.allValues"
            :placeholder="`Filter by ${facet.name}`"
            label="label"
            @input="filterClick($event, facet.name)"
          ></vSelect>
        </div>
      </div>
    </template>

    <!-- <section v-for="(facet, index) in facets" :key="facet.name" :class="">
      <div class="filter-title">
       <a href="javascript:;" @click="toggleItem(index)">
          <h4>{{facet.name}} </h4>
          <i class="icon-caret-right"></i>
       </a>
      </div>

      <div class="facet_links content" >

        <button class="tag"
          :data-label="filter.label"
          :data-filter-string="filter.queryStringParam"
          @click="filterClick"
          v-for="filter in facet.allValues" 
          v-if="!facet.selected"
          :key="filter.name"
        >
            {{filter.label}} ({{filter.count}})
        </button>

        <button class="tag"
          :data-label="filter.label"
          :data-filter-string="filter.queryStringParam"
          @click="removeFilter"

          v-else
        >
        <span class="icon-check"></span>
            {{filter.label}} ({{filter.count}})
        </button>


      </div>
    </section> -->
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "Filters",
  props: ["facets"],
  components: {
    Multiselect,
    vSelect,
  },
  data() {
    return {
      isActive: null,
      value: {},
      show: false,
      windowSmall: false,
      windowWidth: null,
    };
  },
  computed: {
    cleanedFacets() {
      let cleanedFacets = this.facets.map((facet) => {
        facet.allValues = facet.allValues.filter((f) => f.label !== "null");
        return facet;
      });

      return cleanedFacets;
    },
  },
  methods: {
    filterClick(event, facet) {
      // console.log(event.target.dataset);
      console.log(event, facet);
      // this.$emit('filterClick',event.target.dataset.filterString );
      if (event) {
        this.$emit("filterClick", event.queryStringParam, facet);
      } else {
        this.$emit("filterClick", null, facet);
      }
    },
    removeFilter(event) {
      console.log(event.target.dataset);
      this.$emit("removeFilter", event.target.dataset.filterString);
    },
    toggleItem(index) {
      console.log(index);
      this.isActive = this.isActive === index ? null : index;
    },
    filterSelected(event) {
      console.log("filter selected", event);
    },
  },
  created() {
    console.log("Filters has been created!", this.facets);

    let newValues = this.facets.reduce((i, facet) => {
      i[facet.name] = null;
      return i;
    }, {});

    console.log(newValues);
    this.value = newValues;
  },
  mounted() {
    window.innerWidth < 900
      ? (this.windowSmall = true)
      : (this.windowSmall = false);

    window.addEventListener("resize", () => {
      // this.windowWidth = window.innerWidth;
      window.innerWidth < 900
        ? (this.windowSmall = true)
        : (this.windowSmall = false);
    });
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" >
.filter-title a {
  display: flex;
  justify-content: space-between;
}

.filter-toggle {
  &:hover {
    cursor: pointer;
  }
  i {
    float: right;
    font-size: 1.5rem;
  }
}

.select-group {
  > label {
    h4 {
      margin-bottom: 0.2rem;
    }
  }
}

.filters {
  .select-group {
    margin: 1rem 0;

    .v-select {
      background-color: #fff;
      border-radius: 4px;

      .vs__dropdown-toggle {
        border-color: #b3b3b3;
      }

      input {
        &:hover {
          cursor: pointer;
        }
        &::placeholder {
          color: #828282;
        }
      }
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .show-filters {
    display: block;
    animation: fadeIn 0.5s ease-in;
  }

  .hide-filters {
    display: none;
  }
}
</style>